import React, { useState } from 'react';
import { Logo } from './Logo';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="flex justify-between items-center py-4" data-id="element-101">
          <div className="flex-shrink-0" data-id="element-102">
            <div className="h-12 w-auto" data-id="element-103">
              <Logo isSmall={true} data-id="element-104" />
            </div>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-10" data-id="element-105">
            <a href="#about" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-106">
              About
            </a>
            <a href="#services" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-107">
              Services
            </a>
            <a href="#performance" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-108">
              Performance
            </a>
            <a href="#team" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-109">
              Team
            </a>
            <a href="#contact" className="text-slate-700 hover:text-[#D4AF37] transition-colors font-medium" data-id="element-110">
              Contact
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-111">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-slate-700 hover:text-[#D4AF37] focus:outline-none" data-id="element-112">
              {isMenuOpen ? <XIcon size={24} data-id="element-113" /> : <MenuIcon size={24} data-id="element-114" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-115">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-116">
            <a href="#about" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-117">
              About
            </a>
            <a href="#services" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-118">
              Services
            </a>
            <a href="#performance" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-119">
              Performance
            </a>
            <a href="#team" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-120">
              Team
            </a>
            <a href="#contact" className="block px-3 py-2 text-base font-medium text-slate-700 hover:text-[#D4AF37]" data-id="element-121">
              Contact
            </a>
          </div>
        </div>}
    </header>;
};